import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { connect } from "react-redux";
import VinNumber from "src/components/VinNumber/VinNumber";
import { ApplicationStore } from "src/store";
import { getVehicleTitle } from "src/store/selectors/vehicles";
import "./SidebarDetails.scss";

interface Props {
    vin: string;
}

const SidebarDetails = ({ firstName, title, vin }: Props & ReturnType<typeof mapStateToProps>) => {
    const { t } = useTranslation();

    return (
        <p className="SidebarDetails">
            {firstName ? (
                <Trans i18nKey="ContinueDeal.VehicleInfo.detailsTitle1" t={t} values={{ firstName, title }} />
            ) : (
                <Trans i18nKey="ContinueDeal.VehicleInfo.detailsTitle2" t={t} values={{ title }} />
            )}
            <VinNumber>{vin}</VinNumber>
        </p>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => ({
    firstName: state.deal.person?.first_name,
    title: getVehicleTitle(state, vin),
});

export default connect(mapStateToProps)(SidebarDetails);
